//
export default [
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'monto',
        value: 'amount',
        align: 'right',
        format: 'currency',
        input: {
            type: 'currency-field',
            reverse: true,
        },
        width: '12%',
    },
]
